import { Editor } from 'slate'

/**
 * Normalize after a Y undo/redo has finished, not in the middle of it (GH #2073, TUNASONG-WS).
 *
 * slate-yjs applies the undo's Y events to Slate, and Slate normalizes at the end of that step. The
 * normalizer ops are local changes that reach the Y.Doc only on the next onChange. Before that, in
 * the same yjs transaction, slate-yjs's `stack-item-added` handler maps `editor.selection` onto the
 * Y tree by position. If the normalizers changed the structure, the Slate and Y trees disagree and
 * the mapping throws "Path doesn't match yText".
 *
 * Holding normalization until the undo returns keeps the two trees identical while slate-yjs
 * captures and restores selections. The normalizer ops are then stored and flushed as usual.
 */
export const withNormalizeAfterUndo = <T extends Editor & { undo: () => void; redo: () => void }>(editor: T) => {
  const { undo, redo } = editor
  editor.undo = () => Editor.withoutNormalizing(editor, undo)
  editor.redo = () => Editor.withoutNormalizing(editor, redo)
  return editor
}
